import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { QuoteItem } from 'src/models/quote.model';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.scss']
})
export class QuotesComponent implements OnInit {
  quotes: QuoteItem[] = [];
  loading = true;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<QuoteItem[]>('/api/quotes').subscribe({
      next: (data) => {
        this.quotes = data ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = 'Could not load quotes. Please try again later.';
        this.loading = false;
      }
    });
  }
}
